"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWidgetRequiredVersion = getWidgetRequiredVersion;
exports.isSuggestedWidgetView = isSuggestedWidgetView;
exports.resolveWidgetRenderVersion = resolveWidgetRenderVersion;
exports.resolveWidgetEditorVersion = resolveWidgetEditorVersion;
const dataModel_1 = require("./dataModel");
const types_1 = require("./types");
/**
 * Returns the lowest query-engine version required by a widget definition.
 * This is shape classification only; persistence policy remains owned by
 * DashboardService.
 */
function getWidgetRequiredVersion(shape) {
    return (0, dataModel_1.requiresV2)(shape) ? 2 : 1;
}
/**
 * Whether a widget view may be *offered* for a target version. v2 derives
 * traces at read time from the events model, so `viewsV2` — already the
 * allowlist for new v4 widget definitions — is also the suggestion allowlist.
 * Existing `traces` widgets stay readable (v2 has an events-backed traces
 * declaration); they are just not suggested. (LFE-14444)
 */
function isSuggestedWidgetView(view, targetVersion) {
    if (targetVersion !== "v2")
        return true;
    const queryView = types_1.persistedWidgetViewToQueryView[view] ?? view;
    return types_1.viewsV2.safeParse(queryView).success;
}
function resolveEffectiveWidgetVersion(params) {
    return getWidgetRequiredVersion(params.shape) >= 2 ||
        (params.versionFloor ?? 1) >= 2 ||
        params.targetVersion === "v2"
        ? "v2"
        : "v1";
}
/**
 * Selects the newest readable query declaration for a persisted widget.
 * This does not decide or mutate the widget's persisted minVersion.
 */
function resolveWidgetRenderVersion(params) {
    return resolveEffectiveWidgetVersion({
        shape: params.shape,
        versionFloor: params.persistedMinVersion,
        targetVersion: params.newestReadableVersion,
    });
}
/**
 * Selects the declaration used by the widget editor for the active UI mode.
 * The editor's base version is a local floor; saving remains server-owned.
 */
function resolveWidgetEditorVersion(params) {
    return resolveEffectiveWidgetVersion({
        shape: params.shape,
        versionFloor: params.baseMinVersion,
        targetVersion: params.activeVersion,
    });
}
